import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import get from 'lodash/get'
import { DataInput } from './input-col-mobile'
import { InfoData, TaskData } from './info-col-mobile'

export const DataRowMobile = (props) => {
  const myTimesheet = get(props, 'myTimesheet.timesheet.projects', [])

  return (
    <Wrapper>
      { myTimesheet.map((project) => {
        return (
          <InfoRow>
            <ContainerInfo>
              <InfoData
                project={ project }
                projects={ props.projects }
                { ...props }
              />
            </ContainerInfo>
            { get(project, 'tasks', []).map((task, taskID) => {
              return (
                <SumContainer>
                  <FirstCol />
                  <TaskContainer>
                    <Container>
                      <TaskData
                        task={ task }
                        taskID={ taskID }
                        projectID={ project.key }
                        project={ project }
                        { ...props }
                      />
                    </Container>
                    <Container>
                      <DataInput
                        task={ task }
                        taskID={ taskID }
                        projectID={ project.key }
                        project={ project }
                        { ...props }
                      />
                      <LastCol />
                    </Container>
                  </TaskContainer>
                </SumContainer>
              )
            })
            }
          </InfoRow>
        )
      })
      }
    </Wrapper>
  )
}

DataRowMobile.propTypes = {
  projects: PropTypes.array,
}
DataRowMobile.defaultProps = {
  projects: [],
}

const Wrapper = styled.div`
  @media (max-width: 1199.98px) {
    display: none;
  }
  @media (max-width: 991.98px) {
    display: none;
  }
  @media (max-width: 575.98px) {
    background-color: #FFFFFF;
    font-family: 'Gotham-Bold' !important;
    font-size: 16px ;
    display: flex;
    flex-direction: column;
    flex: 1;
    align-items: center;
  }
  @media (max-width: 767.98px) {
    background-color: #FFFFFF;
    font-family: 'Gotham-Bold' !important;
    font-size: 16px ;
    display: flex;
    flex-direction: column;
    flex: 1;
    align-items: center;
  }
  @media (min-width: 1200px) {
    display: none;
  }
`
const Container = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: row;
`
const ContainerInfo = styled.div`
  height: 68px;
  width: 100%;
  padding-bottom: 10px;
  flex: 1;
  display: flex;
  flex-direction: row;
  -moz-box-shadow: 1px 2px 4px rgba(0, 0, 0,0.16);
  -webkit-box-shadow: 1px 2px 4px rgba(0, 0, 0, .16);
  box-shadow: 1px 2px 4px rgba(0, 0, 0, .16);
`
const SumContainer = styled.div`
  @media (min-width: 1200px) {
    display: none;
  }
  width: 100%;
  height: 68px;
  flex: 1;
  display: flex;
  flex-direction: row;
  background-color: #F9F9F9;
`
const FirstCol = styled.div`
  width: 5%;
  display: flex;
  flex-direction: column;
  font-size: 10px;
  border-right: 1px solid #D44B49;
  margin-right: 2%;
`
const LastCol = styled.div`
  width: 10%;
  display: flex;
  flex-direction: column;
  font-size: 10px;
`
const TaskContainer = styled.div`
  @media (min-width: 1200px) {
    display: none;
  }
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  background-color: #F9F9F9;
`
const InfoRow = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`



// WEBPACK FOOTER //
// ./src/components/timesheet/tab-content/my-timesheet/data-row-mobile.js